import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.66,20.07a1.25,1.25,0,0,0-.5,2.45,11,11,0,0,0,2.2.23,10.75,10.75,0,1,0-10-6.65.24.24,0,0,1-.09.29l-1,.73a1,1,0,0,0-.39,1,1,1,0,0,0,.77.77l4,.85.21,0a1,1,0,0,0,.54-.16A1.05,1.05,0,0,0,6.83,19l.94-4.4a1,1,0,0,0-1.56-1l-1.37,1a.24.24,0,0,1-.22,0,.22.22,0,0,1-.16-.16,8.26,8.26,0,1,1,6.2,5.64Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }